import * as types from './actionTypes'

export const deleteKey = (id, entityId) => ({
    type: types.KEY_DELETE,
    id,
    entityId
})

export const deleteKeySuccess = (keys) => ({
    type: types.KEY_DELETE_SUCCESS,
    keys
})

export const deleteKeyFailed = () => ({
    type: types.KEY_DELETE_FAILED
})

export const fetchStatistics = (feedbacks) => ({
    type: types.STATISTICS_FETCH,
    feedbacks
})

export const fetchStatisticsSuccess = (data) => ({
    type: types.STATISTICS_FETCH_SUCCESS,
    data
})

export const fetchStatisticsFailed = () => ({
    type: types.STATISTICS_FETCH_FAILED
})

export const resetStatistics = () => ({
    type: types.STATISTICS_RESET
})

export const getKeysFeedback = (entity) => ({
    type: types.KEYS_GET,
    entity
})

export const getKeysFeedbackSuccess = (keys) => ({
    type: types.KEYS_GET_SUCCESS,
    keys
})

export const getKeysFeedbackFailed = () => ({
    type: types.KEYS_GET_FAILED
})
